import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/funding_form/transit_user_data
export interface UserData {
  firstName: string
  lastName: string
  username: string
  address1: string
  address2: string
  city: string
  state: string
  zipCode: number
  districtId: number
  familyUserId: number
  registrationStatus?: number | null // Registration status from ww_family_users table
  expireTime?: string | null
}

// GET /ajax/family_users/{family_user_id}
export const userData = async () => {
  const response = await new Request().get('/ajax/family_users/user_details')
  return Util.Obj.keysToCamel(response.data.user_details) as UserData
}
